import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { mapListingQtyToMinQty } from "@src/utils/general.utils";
import { expandFilterToken, parseFilterTokens } from "@src/utils/sectionFilter.utils";

export interface MapFilterState {
	section: string;
	sectionStartRange: string;
	sectionEndRange: string;
	row: string;
	rowStartRange: string;
	rowEndRange: string;
	minQuantity: string;
}

export function applyFilterLogic(filterState: MapFilterState) {
	const { section, sectionStartRange, sectionEndRange, row, rowStartRange, rowEndRange, minQuantity } = filterState;

	const selectedSections = new Set<string>();
	const selectedRows = new Set<string>();

	parseFilterTokens(section).forEach((token) => {
		selectedSections.add(token);
		expandFilterToken(token).forEach((value) => selectedSections.add(value));
	});

	const sectionStart = parseInt(sectionStartRange, 10);
	const sectionEnd = parseInt(sectionEndRange, 10);
	if (!isNaN(sectionStart) && !isNaN(sectionEnd)) {
		for (let i = Math.min(sectionStart, sectionEnd); i <= Math.max(sectionStart, sectionEnd); i++) {
			selectedSections.add(i.toString().toUpperCase());
		}
	}

	parseFilterTokens(row).forEach((token) => {
		selectedRows.add(token);
		expandFilterToken(token).forEach((value) => selectedRows.add(value));
	});

	const isLetterRange = /^[a-zA-Z]$/.test(rowStartRange) && /^[a-zA-Z]$/.test(rowEndRange);
	if (isLetterRange) {
		const startChar = rowStartRange.toUpperCase().charCodeAt(0);
		const endChar = rowEndRange.toUpperCase().charCodeAt(0);
		for (let i = Math.min(startChar, endChar); i <= Math.max(startChar, endChar); i++) {
			selectedRows.add(String.fromCharCode(i));
		}
	} else {
		const rowStart = parseInt(rowStartRange, 10);
		const rowEnd = parseInt(rowEndRange, 10);
		if (!isNaN(rowStart) && !isNaN(rowEnd)) {
			for (let i = Math.min(rowStart, rowEnd); i <= Math.max(rowStart, rowEnd); i++) {
				selectedRows.add(i.toString().toUpperCase());
			}
		}
	}

	return {
		selectedSectionNames: Array.from(selectedSections),
		selectedRowNames: Array.from(selectedRows),
		selectedMinQuantity: minQuantity,
	};
}

export function extractMapFilterFromListing(listing: EventInventoryRecord) {
	const row = (listing.Row ?? "").toUpperCase();
	const isLetterRow = /^[A-Z]+$/.test(row);
	const rowStartRange = isLetterRow ? "A" : "1";

	const qty = Number(listing.Quantity);
	const mappedMinQty = mapListingQtyToMinQty(qty);

	return {
		section: "",
		sectionStartRange: "",
		sectionEndRange: "",
		row: "",
		rowStartRange,
		rowEndRange: row,
		minQuantity: mappedMinQty,
	};
}
